export default (details) => {
	const parts = [];

	for (const [key, value] of Object.entries(details)) {
		parts.push(`${key}=${value}`);
	}

	return parts.join(";")
	
}